export var PAGE;
(function (PAGE) {
    PAGE["CONNECTION_METHOD"] = "CONNECTION_METHOD";
    PAGE["OTP_EMAIL"] = "OTP_EMAIL";
    PAGE["OTP_CODE"] = "OTP_CODE";
    PAGE["SELECT_BROKER"] = "SELECT_BROKER";
    PAGE["LOADING"] = "LOADING";
})(PAGE || (PAGE = {}));
export var EXAMPLE_PLAID_CONNECTIONS = [
    "Fidelity",
    "E*Trade",
    "Vanguard",
    "Stash",
    "Merril Lynch",
    "TD Ameritrade",
    "Charles Schwab",
    "Chase",
    "SoFi",
    "Interactive Brokers",
];
export var BOX_SHADOW = "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)";
